import CardTitle from './CardTitle';

export default CardTitle;
